import type { RowData } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { TableInstance, TableRow } from './tanstackTypes';
import type { TableAction } from './types';

export interface DataProviderContext<TData extends RowData> {
  table?: TableInstance<TData>;
  actions: TableAction[];
  toolbarControls?: ReactNode;
  getRowCount: () => number;
  isLoading: boolean;
  isRowIndeterminate?: (row: TableRow<TData>) => boolean;
  isRowHighlighted?: (row: TableRow<TData>) => boolean;
  isRowClickable?: (row: TableRow<TData>) => boolean;
  onRowClick?: (row: TableRow<TData>) => void;
  isPaginationEnabled?: boolean;
  id?: string;
}

export const Context = createContext<DataProviderContext<any>>({
  actions: [],
  getRowCount: () => 0,
  isLoading: false,
});

export const useDataProvider = <TData extends RowData = any>() =>
  useContext(Context) as DataProviderContext<TData>;
